import {
    HomePageAmDocument, HomePageAmQuery, HomePageAmQueryVariables,
    HomePageApDocument, HomePageApQuery, HomePageApQueryVariables,
    HomePageEuDocument,
    HomePageEuQuery, HomePageEuQueryVariables,
    RegionsEnum, UserInputKindDocument,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { generateFiltersConfig } from 'src/utils/generateFiltersConfig.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';

export type HomePageData = Omit<HomePageEuQuery | HomePageApQuery | HomePageAmQuery, '__typename'>;
export type HomePageVariables = Omit<
HomePageEuQueryVariables | HomePageApQueryVariables | HomePageAmQueryVariables, '__typename'
>;

export type HomePageConfig = {
    query: DocumentNode;
    kindQuery: DocumentNode;
    filterConfig: FilterConfig;
}

export const getHomePageConfig = (region: RegionsEnum): HomePageConfig => {
    if (region === RegionsEnum.Eu) {
        return {
            kindQuery: removeDuplicateFragments(UserInputKindDocument),
            query: removeDuplicateFragments(HomePageEuDocument),
            filterConfig: generateFiltersConfig(HomePageEuDocument, 'vssValues')
                .filter((item) => {
                    const [name] = item;
                    return name.substring(0, 3) !== 'raw';
                }),
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            kindQuery: removeDuplicateFragments(UserInputKindDocument),
            query: removeDuplicateFragments(HomePageApDocument),
            filterConfig: generateFiltersConfig(HomePageApDocument, 'vssValues')
                .filter((item) => {
                    const [name] = item;
                    return name.substring(0, 3) !== 'raw';
                }),
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            kindQuery: removeDuplicateFragments(UserInputKindDocument),
            query: removeDuplicateFragments(HomePageAmDocument),
            filterConfig: generateFiltersConfig(HomePageAmDocument, 'vssValues')
                .filter((item) => {
                    const [name] = item;
                    return name.substring(0, 3) !== 'raw';
                }),
        };
    }
    throw new Error('no page config');
};
